export const SERVER_URL = "https://face-detection-server.onrender.com"
// export const SERVER_URL = "http://localhost:3000"